/*
 * Author: Dicky Dichandra / Pacdev
 * Copyright (c) 2022 Optikultur Indonesia
 */

import './App.css'
import { ThemeProvider } from '@mui/material/styles'

import { defaultTheme } from './style/theme'
import Home from './view/Home'
import { Box } from '@mui/material'

function App() {
    return (
        <ThemeProvider theme={defaultTheme}>
            <Box
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '80vh',
                    padding: '10vh 10vw',
                    gap: '8px',
                    backgroundColor: '#f2f4f5',
                }}
            >
                <Home />
            </Box>
        </ThemeProvider>
    )
}

export default App
